import {DialogActions, DialogContent, Typography} from '@mui/material';
import {bool, func, string} from 'prop-types';
import styled from 'styled-components';

import {FONT_FAMILIES} from '../../../const';
import useReport from '../../../hooks/providers/useReport';
import useReportViews from '../../../hooks/providers/useReportViews';
import Button from '../../form/buttons/Button/Button';
import BaseModal from '../../modal/BaseModal';

const List = styled.ul`
  list-style-type: disc;
  padding-left: 1.5rem;
  margin-bottom: 12px;

  li {
    font-family: ${FONT_FAMILIES.BODY};
    font-size: 15px;
    line-height: 1.5;
  }
`;

const WarningRenamingConnectionWillDeleteReportViewsModal = ({open, onClose, onSubmit, siren}) => {
  const {allReportsViews, setAllReportsViews} = useReportViews();
  const {reports} = useReport();

  const getViewsThatWillBeDeletedList = () => {
    return allReportsViews.filter(rv => rv.is_visible && rv.siren?.toString() === siren?.toString());
  };

  const viewsToDelete = getViewsThatWillBeDeletedList();

  const deleteViewsAfterSubmit = () => {
    setAllReportsViews(views => views.filter(v => v.siren?.toString() !== siren?.toString()));
  };

  return (
    <BaseModal title="Suppression des vues" onClose={onClose} open={open}>
      <DialogContent>
        <Typography fontSize={15} mb={2}>
          Renommer ce dossier supprimera toutes les vues ci-dessous, ainsi que celles d’autres utilisateurs (non listées). Action irréversible.
        </Typography>

        <List>
          {viewsToDelete.map(v => {
            const reportName = reports.find(r => r.report_id.toLowerCase() === v.report_id.toLowerCase())?.report_name;
            return (
              <li>
                <b> {v.report_state_name} </b>
                <em>(Rapport : {reportName})</em>
              </li>
            );
          })}
        </List>
      </DialogContent>

      <DialogActions sx={{pb: 1, justifyContent: 'flex-end'}}>
        <Button
          variant="contained"
          color="error"
          onClick={async () => {
            const res = await onSubmit();
            if (res.success) {
              deleteViewsAfterSubmit();
            }
          }}
        >
          Valider la modification
        </Button>
        <Button variant="outlined" color="primary" onClick={onClose}>
          Annuler
        </Button>
      </DialogActions>
    </BaseModal>
  );
};

WarningRenamingConnectionWillDeleteReportViewsModal.propTypes = {
  open: bool.isRequired,
  onClose: func.isRequired,
  onSubmit: func.isRequired,
  siren: string.isRequired
};

export default WarningRenamingConnectionWillDeleteReportViewsModal;
